var app = angular.module('student', ['ui.tree','ui.router', 'ngRoute','angularMoment',
    'ngResource',
    'ngCookies',
    'angular-bugsnag',
    'ui.event',
    'ui.bootstrap',
    'angular-md5',
    'LocalStorageModule',
    'examgen.layout',
    'examgen.service',
    'examgen.constructors',
    'examgen.directive',
    'examgen.controller',
    'angulartics',
    'angulartics.google.analytics',
    'angulartics.mixpanel',
    'vs-repeat',
    'ngSanitize',
    ]);

app.filter('prettyDateTime', function() {
  return function(date) {
    return moment(date).calendar(null,{
      lastWeek: 'MM/DD/YYYY, h:mm a',
      nextWeek: 'MM/DD/YYYY, h:mm a',
      sameElse: 'MM/DD/YYYY, h:mm a'
    });
  };
});
app.filter('prettyDate', function() {
  return function(date) {
    return moment(date).format('MM/DD/YYYY');
  };
});

app.filter('onlyNew', function(){
  return function(items) {
    var res = [];
    var date = new Date();
    for(var i = 0; i < items.length; i++){
      if(items[i].stop > Date.now() && items[i].status < 2){
        res.push(items[i]);
      }
    }
    return res.sort(function(a,b){
      return b.stop-a.stop;
    });
  };
})

app.filter('schoolFilter', function() {
  return function(items,search) {
      var out = [];
      var lc = (search.txt||'').toLowerCase();

      if(items){
        if(lc){
          for(var i = 0; i < items.length; i++){
            var flag = false;
            if(!flag && items[i].name && items[i].name.toLowerCase().includes(lc))flag = true;
            if(!flag && items[i].schoolCode && items[i].schoolCode.toLowerCase().includes(lc))flag = true;

            if(flag && search.state && items[i].stateName != search.state.name)flag = false;

            if(flag)out.push(items[i]);
          }
        } else if(search.state){
          for(var i = 0; i < items.length; i++){
            var flag = true;

            if(search.state && items[i].stateName != search.state.name)flag = false;

            if(flag)out.push(items[i]);
          }
        } else {
          out = items;
        }
      }
      return out;
    }
});

app.config(function($stateProvider, $urlRouterProvider, $httpProvider, $dialogProvider,
    $compileProvider, bugsnagProvider, $sceProvider, localStorageServiceProvider,
    $analyticsProvider) {
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('home', {
      url: '/',
      controller: 'studentHomeCtrl',
      templateUrl: 'partials/home.html',
    })
    .state('assignment', {
      url: '/assignment/:id',
      params: {
          id: ''
      },
      controller: 'studentAssignmentCtrl',
      templateUrl: 'partials/assignment.html',
    })
    .state('review', {
      url: '/review/:id',
      params: {
          id: ''
      },
      controller: 'studentAssignmentCtrl',
      templateUrl: 'partials/review.html',
    })

  $dialogProvider.options({keyboard: false, backdropClick: false});
  $.fn.modal.defaults = {keyboard: false, backdrop: 'static'};
});

app.run(function($rootScope, $state, $http, $window, $q, flashMessages, $sce, $timeout) {
  $rootScope.state = $state;
  $rootScope.loginRequired = false;
  $rootScope.createAccount = false;
  $rootScope.extraInstructions = 'Use the school lookup to find schools by name or the schools code you recived in your Email. You can use the state selection to restrict schools to a specific state.';
  $rootScope.$window = $window;
  $rootScope.version = $window.VERSION;
  $rootScope.$safeApply = function(fn) {
      var phase = this.$root.$$phase;
      if(phase === '$apply' || phase === '$digest') {
          if(fn && (typeof(fn) === 'function')) {
              fn();
          }
      } else {
          this.$apply(fn);
      }
  };

  $rootScope.schoolSearch = {txt:null, state:null};
  $rootScope.schoolStates = [];
  $rootScope.helpIndex = 0;

  function setupSessionTimeout(){
    var sessionTimeout;
    var SESSION_TIMEOUT = 30 * 60 * 1000; //30 minutes

    //TODO: set capture
    if(document.documentElement.addEventListener){
      ['keyup','keydown','mouseclick','mousemove'].forEach(function(ev){
          document.documentElement.addEventListener(ev,function(e){
            renewSessionTimeout();
          }, true);
      });
    }

    function renewSessionTimeout(){
      clearTimeout(sessionTimeout);

      sessionTimeout = setTimeout(function() {
        // @todo implement differently
        // if (window.ENV === 'development') {
        //   return;
        // }

        //delete session
        $rootScope.$safeApply(function() {
          $rootScope.exitSavePrompt = false;
          window.href = '/logout?origin=/student/';
        });
      }, SESSION_TIMEOUT);
    }
    renewSessionTimeout();
  }

  displayFlashMessages(flashMessages.get());

  $('body').addClass('page-loaded');

  setTimeout(function() {
      $('body').removeClass('page-loading').removeClass('page-loaded');
  }, 1500);

  $rootScope.$watch('schoolSearch.state',function(state){
    if(state){
      localStorage.setItem('lastSchoolState',state.idState);
    }
  });

  $http.get('/session',{
    headers:{
      Authorization: 'Bearer '+localStorage.getItem('studentToken')
    }
  }).then(function(response){
    if(!response.data){
      $rootScope.loginRequired = true;
    }else{
      if(!response.data.idStudent)
        window.location.href = '/logout?origin='+$window.location.href;
      else {
        $rootScope.profile = response.data;
        localStorage.setItem('lastSchool', $rootScope.profile.fkSchool);
        if(!$rootScope.profile.password){
          $rootScope.setPassword = true;
        }
        setupSessionTimeout();
      }
    }
  });

  $http.get('/api/schools/all')
  .then(function(res){
    $rootScope.schools = res.data;
    var lastSchool = localStorage.getItem('lastSchool');
    for(var i = 0; i < $rootScope.schools.length; i++){
      if($rootScope.schools[i].idSchool==lastSchool)
        $rootScope.school = $rootScope.schools[i];
    }
  });

  $http.get('/api/state/list')
  .then(function(res){
    $rootScope.schoolStates = res.data;
    var lastState = localStorage.getItem('lastSchoolState');
    for(var i = 0; i < $rootScope.schoolStates.length; i++){
      if($rootScope.schoolStates[i].idState==lastState)
        $rootScope.schoolSearch.state = $rootScope.schoolStates[i];
    }
  });


  $rootScope.$watch('school',function(school){
    if(school) localStorage.setItem('lastSchool',school.idSchool);
  });

  function filterStates(){
    if($rootScope.schools && $rootScope.schoolStates){
      for(var i = 0; i <  $rootScope.schoolStates.length; i++){
        if($rootScope.schools.findIndex((s)=>s.stateName==$rootScope.schoolStates[i].name) == -1){
          $rootScope.schoolStates.splice(i,1);
          i--;
        }
      }
    }
  }
  $rootScope.$watch('schools',filterStates);
  $rootScope.$watch('schoolStates',filterStates);

  $http.get('/api/helpdocs?type=1').then(function(res){
    $rootScope.helpDocs = [];
    for(var i = 0; i < res.data.length; i++){
      res.data[i].html = $sce.trustAsHtml(res.data[i].html);
      if(res.data[i].title == 'homeHelp'){
        $rootScope.homeHelp = res.data[i];
      } else if(res.data[i].order >= 0){
        $rootScope.helpDocs.push(res.data[i]);
      }
    }
    $rootScope.helpDocs.sort(function(a,b){
      return a.order-b.order;
    })
  });
  $rootScope.displayHelp = function(val) {
    $rootScope.helpIndex = 0;
    $rootScope.showHelp = !!val;
  }
  $rootScope.setHelpIndex = function(i){
    $rootScope.helpIndex = i;
  }

  var pinger;
  var ping = function() {
      $.ajax({url: '/ping?' + new Date().getTime()}).done(function( data ) {
        if(data){
          localStorage.setItem('studentToken', data.token);
          if(!data.loggedin)$timeout(function() {
            $rootScope.loginRequired = true;
            $rootScope.$apply();
          });
        }
      }).fail(function() {
        alertify.error('Unable to communicate with server, please check your internet connection');
      }).always(function() {
          pinger = setTimeout(ping, 30*1000);
      })
  };

  if(pinger)clearTimeout(pinger);
  ping();
});

app.controller('formCtrl', function($rootScope, $scope){

});
